<template>
  <v-card class="custom-card">
    <v-row>
      <v-col>
        <!-- Header (Date and Logos) -->
        <v-row class="header-row">
          <!-- Date and Time -->
          <v-col>
            <div class="green-label">Evolução</div>
            <div style="margin-top: 18px">
              <div class="gray-label">Saldo actual</div>
              <div class="big-black-value">
                {{ formatCurrency(stats.currentBalance) }}
              </div>
            </div>
          </v-col>
          <v-col class="statistics-col">
            <div class="gray-label">Saldo inicial</div>
            <div class="black-value">
              {{ formatCurrency(stats.initialBalance) }}
            </div>
            <div class="gray-label">Lucro/prejuízo</div>
            <div
              :class="stats.profit < 0 ? 'black-value negative' : 'black-value'"
            >
              {{ formatCurrency(stats.profit) }}
            </div>
          </v-col>
          <v-col class="statistics-col">
            <div class="gray-label">ROI/yeald</div>
            <div class="black-value">
              {{ stats.roi ? parseFloat(stats.roi).toFixed(2): 0 }}%
            </div>
            <div class="gray-label">Greens</div>
            <div class="black-value">
              <v-icon size="16" color="#26AB5E">mdi-check-circle-outline</v-icon
              >{{ stats.greens }}
            </div>
          </v-col>
          <v-col class="statistics-col">
            <div class="gray-label">Odd média</div>
            <div class="black-value">
              {{ stats.avgOdd ? parseFloat(stats.avgOdd).toFixed(2): 0 }}
            </div>
            <div class="gray-label">Reds</div>
            <div class="black-value">
              <v-icon size="16" color="#F83030">mdi-close-circle-outline</v-icon
              >{{ stats.reds }}
            </div>
          </v-col>
          <v-col class="statistics-col">
            <div class="gray-label">Stake média</div>
            <div class="black-value">
              {{ stats.avgStake ? parseFloat(stats.avgStake).toFixed(2): 0 }}
            </div>
            <div class="gray-label">Voids</div>
            <div class="black-value">
              <v-icon size="16" color="#D8E0E6">mdi-minus-circle-outline</v-icon
              >{{ stats.voids }}
            </div>
          </v-col>
        </v-row>
        <!-- CHART -->
        <v-row class="chart-row">
          <v-col cols="12">
            <BarChart
              v-if="loaded"
              :stats="monthlyStats"
              :months="months"
              :profits="profits"
              class="chart"
              :key="'chart-' + bankVersion"
            ></BarChart>
          </v-col>
        </v-row>

        <!-- BUTTONS -->
        <v-row class="buttons-row">
          <v-col class="small-btn" style="padding-right: 4px">
            <!-- RESET BANK DIALOG -->
            <v-dialog v-model="resetDialog" max-width="372" v-if="isPremium()">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  block
                  large
                  depressed
                  color="#D8E0E6"
                  class="gray-button"
                  >Reset à banca</v-btn
                >
              </template>
              <v-card>
                <v-card-title align="center">Reset Banca Virtual</v-card-title>
                <v-card-text style="padding: 0 48px 20px"
                  >Tem a certeza que pretende fazer reset à sua banca virtual?
                  Ao continuar vai perder todo o seu histórico de apostas no
                  bigómetro.</v-card-text
                >
                <v-list-item style="padding: 0 24px 12px 24px">
                  <v-list-item-content style="padding-right: 8px">
                    <v-btn
                      block
                      depressed
                      color="secondary"
                      height="48"
                      @click="resetDialog = false"
                      >Cancelar</v-btn
                    >
                  </v-list-item-content>
                  <v-list-item-content style="padding-left: 8px">
                    <v-btn
                      block
                      depressed
                      dark
                      color="#F83030"
                      height="48"
                      @click="resetBank()"
                      >Reset</v-btn
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-dialog>
            <v-btn
              v-else
              block
              large
              depressed
              color="#D8E0E6"
              class="gray-button"
              >Reset à banca</v-btn
            >
          </v-col>
          <v-col class="small-btn" style="padding-left: 4px">
            <!-- CREATE BANK DIALOG -->
            <v-dialog
              v-model="createDialog"
              max-width="372"
              v-if="isPremium() && getBalance() == 0"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  block
                  large
                  depressed
                  color="rgba(38, 171, 94, 0.3)"
                  class="green-button"
                  >Criar banca</v-btn
                >
              </template>
              <v-card>
                <v-card-title align="center">Criar Banca Virtual</v-card-title>
                <v-card-text style="padding: 0 48px 12px"
                  >Com a banca virtual simulas todas as apostas como se fossem
                  reais e participar no bigómetro, adquirindo experiência e
                  autocontrole.</v-card-text
                >
                <v-list-item style="padding: 12px 24px 36px 24px">
                  <v-text-field
                    dense
                    filled
                    hide-details
                    class="dialog-text"
                    height="48px"
                    type="number"
                    v-model="bankAmount"
                  >
                    <template v-slot:prepend-inner> € </template>
                    <template v-slot:append> .00 </template>
                  </v-text-field>
                </v-list-item>
                <v-list-item style="padding: 0 24px 12px 24px">
                  <v-list-item-content style="padding-right: 8px">
                    <v-btn
                      block
                      depressed
                      color="secondary"
                      height="48"
                      @click="createDialog = false"
                      >Cancelar</v-btn
                    >
                  </v-list-item-content>
                  <v-list-item-content style="padding-left: 8px">
                    <v-btn
                      block
                      depressed
                      color="primary"
                      height="48"
                      @click="createBank()"
                      >Criar</v-btn
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-dialog>
            <v-btn
              v-else
              block
              large
              depressed
              color="#D8E0E6"
              class="gray-button"
              >Criar banca</v-btn
            >
          </v-col>
          <v-spacer></v-spacer>
          <v-col class="large-btn">
            <v-btn
              block
              large
              depressed
              :color="isPremium() ? 'primary' : '#D8E0E6'"
              :class="isPremium() ? '' : 'gray-button'"
              :to="isPremium() ? '/bigometro' : ''"
              v-if="isComponent"
              >Jogar</v-btn
            >
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<style scoped>
.custom-card.v-card {
  padding: 0 24px !important;
}
.header-row .col:first-child {
  min-width: 150px;
  position: relative;
}
.green-label {
  font-size: 11px;
  line-height: 16px;
  padding-bottom: 0;
  font-family: Gilroy-Bold;
  color: #26ab5e;
  padding-right: 4px;
  vertical-align: top;
}
.gray-label {
  font-family: Gilroy-SemiBold;
  font-size: 11px;
  line-height: 16px;
  color: #bcc5cc;
}
.black-value {
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 24px;
  color: #304351;
}
.positive::first-letter {
  color: #26ab5e;
}
.negative::first-letter {
  color: #f83030;
}
.big-black-value {
  overflow-wrap: initial;
  font-family: Gilroy-SemiBold;
  font-size: 24px;
  line-height: 28px;
  color: #304351;
}
.header-row .v-icon {
  float: left;
  margin-top: 3px;
  margin-right: 4px;
}
.chart-row {
  background: #f7f9fa;
  left: -12px;
  position: relative;
  width: calc(100% + 48px);
  border-top: 1px solid #d8e0e6;
  border-bottom: 1px solid #d8e0e6;
}
.chart-row .col {
  padding: 12px 24px;
}
.chart {
  height: 118px;
  position: relative;
  width: 100%;
}
.buttons-row .col {
  padding-top: 20px;
}
.green-button >>> .v-btn__content {
  color: #26ab5e;
}
.small-btn {
  flex: 0 0 26%;
  max-width: 26%;
}
.dialog-text >>> .v-input__slot {
  background-color: #bee6cf !important;
  border-radius: 4px !important;
}
.dialog-text >>> .v-text-field__slot input,
.dialog-text >>> .v-input__slot {
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 24px;
  color: #26ab5e;
  padding: 0 !important;
}
.dialog-text >>> .v-text-field__slot input::-webkit-outer-spin-button,
.dialog-text >>> .v-text-field__slot input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
.dialog-text >>> .v-text-field__slot input[type="number"] {
  -moz-appearance: textfield;
}
.dialog-text >>> .v-input__slot::before,
.dialog-text >>> .v-input__slot::after {
  display: none !important;
}
.dialog-text >>> .v-text-field__slot {
  padding-left: 16px;
}
.dialog-text >>> .v-input__prepend-inner {
  color: #ffffff;
  background: #26ab5e;
  border-top-left-radius: 6px !important;
  border-bottom-left-radius: 6px !important;
  padding: 17px 23px;
  margin: 0 !important;
}
.dialog-text >>> .v-input__append-inner {
  margin: 0 !important;
  padding: 17px;
  border-left: 1px solid #26ab5e;
}
@media only screen and (max-width: 767px) {
  .statistics-col {
    flex: 0 0 33%;
    max-width: 33%;
  }
}
@media only screen and (max-width: 480px) {
  .small-btn {
    min-width: 50%;
  }
}
</style>

<script>
import Vue from "vue";
import BarChart from "@/components/BarChart.vue";

import ApiService from "@/services/api.service";
import DateTimeService from "@/services/datetime.service";

export default Vue.extend({
  name: "PrognosticoCard",
  components: {
    BarChart,
  },
  props: {
    isComponent: Boolean,
  },
  data: () => ({
    resetDialog: false,
    createDialog: false,
    bankAmount: 0,
    stats: {},
    monthlyStats: {},
    months: [],
    profits: [],
    loaded: false,
    bankVersion: 0,
  }),
  created() {
    this.getStats();
    this.getMonthlyStats();
  },
  methods: {
    isBackoffice() {
      return this.$route.path.includes("backoffice");
    },
    getStats() {
      ApiService.getBankStats(this.isBackoffice()).then(
        (response) => {
          this.stats = response.data;
          this.$store.commit("setBalance", this.stats.currentBalance);
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    getMonthlyStats() {
      ApiService.getMonthlyBankStats(this.isBackoffice()).then(
        (response) => {
          this.monthlyStats = response.data;
          this.months = response.data.map((list) => {
            return DateTimeService.getMonthString(list.month);
          });
          this.profits = response.data.map((list) => {
            return list.profit;
          });
          this.bankVersion += 1;
          this.loaded = true;
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    createBank() {
      ApiService.createBank(this.isBackoffice(), this.bankAmount).then(
        (response) => {
          this.createDialog = false;
          this.stats = response.data;
          this.$store.commit("setBalance", this.stats.currentBalance);
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    resetBank() {
      ApiService.resetBank(this.isBackoffice()).then(
        (response) => {
          this.resetDialog = false;
          this.stats = response.data;
          this.$store.commit("setBalance", this.stats.currentBalance);
          this.getMonthlyStats();
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    formatCurrency(value) {
      const number = value ? value : 0;
      return number.toLocaleString("de-DE", {
        style: "currency",
        currency: "EUR",
      }); /* $2,500.00 */
    },
    isPremium() {
      return this.$store.state.premium;
    },
    getBalance() {
      return this.$store.state.balance ? this.$store.state.balance : 0;
    },
  },
});
</script>
